import * as React from 'react';
import { SVGProps } from 'react';

const IconInfoCircleSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM9.292 4.072a1.072 1.072 0 1 1-2.144 0 1.072 1.072 0 0 1 2.144 0Zm-1.98 8.676a1.9 1.9 0 0 0 2.129-.164l.03-.023c.366-.293.615-.707.701-1.168l.183-.974a.15.15 0 0 0-.147-.177H8.753a.15.15 0 0 0-.147.122l-.133.71a.225.225 0 0 1-.081.135l-.03.024a.17.17 0 0 1-.273-.163l.858-4.153v-.003a.865.865 0 0 0-.85-1.024H6.418a.15.15 0 0 0-.145.113l-.357 1.43a.15.15 0 0 0 .145.186h.99l-.66 3.127-.001.003a1.9 1.9 0 0 0 .923 2Z"
    />
  </svg>
);
export default IconInfoCircleSizeS;
